const becomeSellerPk = {
	breadcrumbs: {
		home: 'ہوم',
		becomeSeller: 'سیلر بنیں'
	},
	hero: {
		title: 'سیلر بنیں',
		subtitle: 'گرامین بازار کے ساتھ اپنا کاروبار بڑھائیں اور لاکھوں گاہکوں تک پہنچیں',
		cta: 'ابھی شروع کریں'
	},
	stats: [
		{ value: '50,000+', label: 'فعال سیلرز' },
		{ value: '98%', label: 'بروقت ادائیگیاں' },
		{ value: '300%', label: 'اوسط فروخت میں اضافہ' },
		{ value: '4.8/5', label: 'سیلر اطمینان' }
	],
	benefits: {
		title: 'بیچنے کے فوائد',
		items: [
			{ title: 'فروخت بڑھائیں', description: 'اپنی مصنوعات 1M+ گاہکوں تک پہنچائیں' },
			{ title: 'زیادہ کمائیں', description: 'مقابلہ جاتی کمیشن ریٹس اور تیز ادائیگیاں' },
			{ title: '24/7 سپورٹ', description: 'ہماری ڈیدیکیٹڈ سیلر سپورٹ ٹیم ہمیشہ آپ کے ساتھ ہے' },
			{ title: 'محفوظ لین دین', description: 'مکمل محفوظ اور شفاف ادائیگی نظام' },
			{ title: 'تیز سیٹ اپ', description: '24 گھنٹوں میں اپنی دکان لانچ کریں' },
			{ title: 'سیلز اینالیٹکس', description: 'تفصیلی رپورٹس اور سیلز ٹریکنگ' }
		]
	},
	steps: {
		title: 'آغاز کیسے کریں',
		stepNumbers: ['۱', '۲', '۳'],
		items: [
			{ title: 'رجسٹریشن', description: 'اپنی ذاتی اور کاروباری معلومات کے ساتھ رجسٹر کریں' },
			{ title: 'تصدیق', description: 'ہماری ٹیم 24 گھنٹوں میں جانچ کر کے منظور کرے گی' },
			{ title: 'فروخت شروع کریں', description: 'پراڈکٹس اپلوڈ کریں اور فروخت شروع کریں' }
		]
	},
	cta: {
		title: 'آج ہی اپنا ڈیجیٹل کاروبار شروع کریں',
		subtitle: 'گرامین بازار کے ساتھ جڑیں اور اپنے کاروبار کو نئی بلندیوں تک لے جائیں',
		button: 'سیلر کے طور پر شامل ہوں'
	},
	transformDreams: {
		title: "گریمین بازار کے ساتھ اپنے خوابوں کو حقیقت بنائیں",
		content: [
			"تصور کریں کہ آپ کا کاروبار کیسے ترقی کر رہا ہے – نہ صرف پہچان والے چہروں کے ساتھ، بلکہ ہر گاؤں کے نئے گاہکوں کے ساتھ بھی، جو پہلی بار آپ کو دریافت کر رہے ہیں۔ گریمین بازار میں، آپ کی مصنوعات ایسے لوگوں کی روزمرہ کی زندگی کا حصہ بن جاتی ہیں جنہوں نے پہلے کبھی کسی مارکیٹ پلیس سے خریداری نہیں کی تھی۔",
			"ہماری طاقتور مارکیٹنگ گہری دیہی برادریوں تک پہنچتی ہے، پڑوسیوں اور دوستوں کو ایک ساتھ لاتی ہے جو آپ جیسے مقامی فروخت کنندگان کی حمایت کرنا چاہتے ہیں۔ ہمارے حالیہ سروے نے ایک شاندار حقیقت ظاہر کی: ہمارے تقریباً 30% خریدار پہلی بار مارکیٹ پلیس کے گاہک بنے ہیں، جو آپ سے خریداری کرنے کے لیے تیار اور پُرجوش ہیں۔",
			"یہ ایک ایسا موقع ہے جو آپ کو پہلے کبھی نہیں ملا – ایسے لوگوں تک پہنچنے کا، جو پہلے آپ کی پہنچ سے باہر تھے؛ انہیں اپنی کہانی کا حصہ بنانے کا، اور اپنی فروخت میں 50% سے 100% یا اس سے بھی زیادہ اضافہ کرنے کا۔ گریمین بازار کا حصہ بنیں – یہ صرف ایک پلیٹ فارم نہیں، بلکہ ایک تحریک ہے۔",
			"آئیے، مل کر امید، مواقع اور خوشحالی آپ کے خاندان، آپ کے گاؤں اور آپ کے خوابوں تک پہنچائیں۔ گاہک انتظار کر رہے ہیں – اب آپ کے چمکنے کا وقت ہے۔"
		]
	}
	
};

export default becomeSellerPk;


